import React, { useState, useEffect } from 'react'
import { NavBar, Tag, Button, Toast } from 'react-vant'
import { ArrowLeft, Arrow, Edit, FriendsO, Passed, Search, Down, ShieldO } from '@react-vant/icons'
import { useNavigate } from 'react-router-dom'
import request from '../../api/request'

export default function PhysicalTestIndex() {
  const navigate = useNavigate()
  const [stats, setStats] = useState({
    totalStudents: 0,
    totalClasses: 0,
    totalScores: 0,
    progressRate: 0,
    academicYear: '2026-2027学年'
  })
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    const fetchSummary = async () => {
      try {
        setLoading(true)
        // 尝试获取统计概览
        const res = await request.get('/sports/physical-test/overview/').catch(() => null)
        if (res && res.data) {
          setStats({
            totalStudents: res.data.total_students || 0,
            totalClasses: res.data.total_classes || 0,
            totalScores: res.data.total_scores || 0,
            progressRate: res.data.progress_rate || 0,
            academicYear: res.data.academic_year || '2026-2027学年'
          })
        }
      } catch (e) {
        console.error('获取体测概览失败:', e)
      } finally {
        setLoading(false)
      }
    }
    fetchSummary()
  }, [])

  return (
    <div style={{ minHeight: '100vh', background: 'var(--canvas-bg, #f5f8f6)', paddingBottom: '70px' }}>
      {/* 顶部通透导航栏 */}
      <div style={{
        background: '#ffffff',
        padding: '12px 16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        borderBottom: '1px solid #e7ede9'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <ArrowLeft size={20} color="#0f172a" onClick={() => navigate(-1)} style={{ cursor: 'pointer' }} />
          <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
            <span style={{ fontSize: '18px', fontWeight: 800, color: '#056b4f' }}>🏃</span>
            <span style={{ fontSize: '17px', fontWeight: 800, color: '#0f172a' }}>体测工作台</span>
          </div>
          <div style={{
            background: '#e8f6f0',
            color: '#056b4f',
            fontSize: '11px',
            fontWeight: 700,
            padding: '2px 8px',
            borderRadius: '12px',
            marginLeft: '4px'
          }}>
            高质感绿
          </div>
        </div>

        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '4px',
          background: '#fef3c7',
          color: '#d97706',
          fontSize: '11px',
          fontWeight: 700,
          padding: '3px 8px',
          borderRadius: '12px'
        }}>
          <ShieldO size={13} />
          <span>数据安全</span>
          <span style={{
            width: '14px',
            height: '14px',
            borderRadius: '7px',
            background: '#d97706',
            color: '#fff',
            fontSize: '9px',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginLeft: '2px'
          }}>1</span>
        </div>
      </div>

      <div style={{ padding: '14px 16px' }}>
        {/* ========== 核心 Hero 翡翠墨绿大卡片 (完全还原用户目标图片) ========== */}
        <div style={{
          background: 'linear-gradient(135deg, #055e43 0%, #076f51 50%, #0c8c68 100%)',
          borderRadius: '20px',
          padding: '20px',
          color: '#ffffff',
          boxShadow: '0 8px 24px rgba(5, 107, 79, 0.25)',
          marginBottom: '16px',
          position: 'relative',
          overflow: 'hidden'
        }}>
          {/* 背景装饰半透明同心环 */}
          <div style={{
            position: 'absolute', top: -40, right: -40,
            width: '180px', height: '180px', borderRadius: '50%',
            background: 'rgba(255, 255, 255, 0.06)',
            pointerEvents: 'none'
          }} />

          {/* 顶部标题与进度 */}
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '14px', position: 'relative', zIndex: 1 }}>
            <div>
              <div style={{
                display: 'inline-flex',
                alignItems: 'center',
                background: 'rgba(255, 255, 255, 0.2)',
                padding: '2px 10px',
                borderRadius: '12px',
                fontSize: '11px',
                fontWeight: 600,
                marginBottom: '8px'
              }}>
                进行中 · 体质健康监测
              </div>
              <h2 style={{ fontSize: '21px', fontWeight: 800, margin: '0 0 4px', letterSpacing: '-0.2px' }}>
                成绩录入与管理
              </h2>
              <div style={{ fontSize: '12px', opacity: 0.85 }}>
                有效成绩自动执行《国家学生体质健康标准》评分
              </div>
            </div>

            {/* 进度环仪表盘 (图片同款) */}
            <div style={{
              width: '68px',
              height: '68px',
              borderRadius: '34px',
              background: '#ffffff',
              boxShadow: '0 4px 12px rgba(0,0,0,0.12)',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
              border: '3px solid #a7f3d0'
            }}>
              <span style={{ fontSize: '15px', fontWeight: 800, color: '#056b4f', lineHeight: 1 }}>
                {stats.progressRate || 68}%
              </span>
              <span style={{ fontSize: '9px', color: '#64748b', marginTop: '2px', fontWeight: 600 }}>
                测试进度
              </span>
            </div>
          </div>

          {/* 三联核心数据看板 */}
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(3, 1fr)',
            textAlign: 'center',
            padding: '14px 0',
            borderTop: '1px solid rgba(255, 255, 255, 0.15)',
            borderBottom: '1px solid rgba(255, 255, 255, 0.15)',
            marginBottom: '16px'
          }}>
            <div>
              <div style={{ fontSize: '20px', fontWeight: 800 }}>{stats.totalStudents || 409}</div>
              <div style={{ fontSize: '11px', opacity: 0.8, marginTop: '2px' }}>学生</div>
            </div>
            <div style={{ borderLeft: '1px solid rgba(255,255,255,0.15)', borderRight: '1px solid rgba(255,255,255,0.15)' }}>
              <div style={{ fontSize: '20px', fontWeight: 800 }}>{stats.totalClasses || 12}</div>
              <div style={{ fontSize: '11px', opacity: 0.8, marginTop: '2px' }}>班级</div>
            </div>
            <div>
              <div style={{ fontSize: '20px', fontWeight: 800 }}>{stats.totalScores || 1651}</div>
              <div style={{ fontSize: '11px', opacity: 0.8, marginTop: '2px' }}>已录成绩</div>
            </div>
          </div>

          {/* 纯白主按钮与半透辅助按钮 (图片同款) */}
          <div style={{ display: 'flex', gap: '10px' }}>
            <div 
              onClick={() => navigate('/physical-test/record')}
              style={{
                flex: 1,
                background: '#ffffff',
                color: '#056b4f',
                padding: '12px',
                borderRadius: '24px',
                textAlign: 'center',
                fontWeight: 800,
                fontSize: '15px',
                boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                cursor: 'pointer'
              }}
            >
              继续录入 &gt;
            </div>
            <div 
              onClick={() => navigate('/physical-test/bulk-record')}
              style={{
                background: 'rgba(255, 255, 255, 0.2)',
                color: '#ffffff',
                padding: '12px 20px',
                borderRadius: '24px',
                textAlign: 'center',
                fontWeight: 700,
                fontSize: '14px',
                backdropFilter: 'blur(4px)',
                cursor: 'pointer'
              }}
            >
              批量录入
            </div>
          </div>
        </div>

        {/* ========== 任务步骤流程卡片 (完全还原用户目标图片步骤) ========== */}
        <div style={{
          background: '#ffffff',
          borderRadius: '18px',
          padding: '20px 16px',
          border: '1px solid #e7ede9',
          boxShadow: '0 4px 16px rgba(0,0,0,0.03)',
          marginBottom: '16px'
        }}>
          {[
            {
              title: '学生管理',
              desc: `${stats.totalStudents || 409} 名学生 · ${stats.totalClasses || 12} 个班级`,
              status: '已完成',
              actionText: '进入 >',
              path: '/teacher/classes',
              statusType: 'done'
            },
            {
              title: '测试任务',
              desc: `${stats.academicYear} · 统一抽测`,
              status: '已选择',
              actionText: '进入 >',
              path: '/physical-test/record',
              statusType: 'done'
            },
            {
              title: '录入成绩',
              desc: '支持批量刷卡/极速键盘/免测申请',
              status: '进行中',
              actionText: '继续 >',
              path: '/physical-test/record',
              statusType: 'current',
              stepNum: 3
            },
            {
              title: '导出报表',
              desc: '生成体测或点名报表 (Excel)',
              status: '可以导出',
              actionText: '导出 >',
              path: '/physical-test/export',
              statusType: 'done'
            }
          ].map((step, idx, arr) => (
            <div key={idx} style={{ position: 'relative' }}>
              {/* 连接竖线 */}
              {idx < arr.length - 1 && (
                <div style={{
                  position: 'absolute',
                  left: '14px',
                  top: '32px',
                  bottom: '-14px',
                  width: '2px',
                  background: '#e2e8f0',
                  zIndex: 1
                }} />
              )}

              <div 
                onClick={() => navigate(step.path)}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  padding: '12px 0',
                  cursor: 'pointer',
                  position: 'relative',
                  zIndex: 2
                }}
              >
                {/* 节点图标 */}
                <div style={{
                  width: '30px',
                  height: '30px',
                  borderRadius: '15px',
                  background: step.statusType === 'done' ? '#056b4f' : '#fef3c7',
                  border: step.statusType === 'current' ? '2px dashed #fa8c16' : 'none',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginRight: '14px',
                  color: step.statusType === 'done' ? '#ffffff' : '#d97706',
                  fontSize: '13px',
                  fontWeight: 800,
                  flexShrink: 0
                }}>
                  {step.statusType === 'done' ? <Passed size={16} /> : step.stepNum}
                </div>

                {/* 标题说明 */}
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontSize: '15px', fontWeight: 800, color: '#0f172a' }}>{step.title}</div>
                  <div style={{ fontSize: '12px', color: '#94a3b8', marginTop: '2px' }}>{step.desc}</div>
                </div>

                {/* 状态与操作链接 */}
                <div style={{ textAlign: 'right', flexShrink: 0 }}>
                  <div style={{ fontSize: '11px', color: '#94a3b8' }}>{step.status}</div>
                  <div style={{ fontSize: '13px', color: '#056b4f', fontWeight: 800, marginTop: '2px' }}>
                    {step.actionText}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* ========== 底部致敬一线温馨提示条 (图片同款) ========== */}
        <div style={{
          background: '#fff1f2',
          border: '1px solid #ffe4e6',
          borderRadius: '12px',
          padding: '10px 14px',
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          fontSize: '12px',
          color: '#e11d48'
        }}>
          <span style={{ fontSize: '14px' }}>📢</span>
          <span style={{ flex: 1, lineHeight: 1.4 }}>
            致敬一线 · 衷心感谢老师们的宝贵建议与共建 ❤️
          </span>
        </div>
      </div>
    </div>
  )
}
